module.exports = __webpack_public_path__ + "img/588x310-03.f64b35f2.png";